import { useSelector } from 'react-redux'
import useViewport from '../../common/hooks/useViewport'
import { Element } from '../../common/html/element'
import { Loading } from '../../common/loading'
import { Notification } from '../../common/notification'
import { ScrollComponent } from '../../common/scrollComponent'
import { Footer } from '../../layout/footer'
import { responsive } from '../../utils/layout'
import { BackButton } from './BackButton'
import { TriggerDate } from './TriggerDate'
import { Alerts } from './alerts'
import { ChangeBasic } from './changeBasic'
import { ChangeLimitScore } from './changeLimitScore'
import { ChangePeriod } from './changePeriod'
import { ChangeStatus } from './changeStatus'
import { ChangeTable } from './changeTable'
import { ChangerFinancial } from './changerFinancial'
import { ALERT_TYPE_CODE } from './constant'
import { FilingStatus } from './filingStatus'
import { Header } from './header'
import './i18n'
import classes from './index.module.scss'
import { Industry } from './industry'
import { Infor } from './infor'
import { Macroeconomic } from './macroeconomic'
import { News } from './news'
import { Portfolios } from './portfolios'
import { selectAlertDetail, selectLoading } from './store/slice'
import { UpdateFS } from './updateFS'

const mapPanel = {
  NEWS: News,
  CHANGEBASIC: ChangeBasic,
  CHANGESTATUS: ChangeStatus,
  CHANGEPERIOD: ChangePeriod,
  UPDATEFS: UpdateFS,
  CHANGERFINANCIAL: ChangerFinancial,
  UPDATETAX: FilingStatus,
  UPDATEINSURANCE: FilingStatus,
  UPDATEINVOICE: FilingStatus,
  MANAGEMENTCHANGE: ChangeTable,
  OWNERSHIPCHANGE: ChangeTable,
  INFOR: Infor,
  CHANGELIMITSCORE: ChangeLimitScore,
  MACROECONOMIC: Macroeconomic,
  INDUSTRY: Industry,
}

export const Content = () => {
  const { width } = useViewport()
  const alertDetail = useSelector(selectAlertDetail)
  const isLoading = useSelector(
    selectLoading(['companyInfo', 'alertDetail', 'alertList']),
  )

  const isMacro =
    alertDetail?.alertTypeCode === ALERT_TYPE_CODE.MACROECONOMIC.key
  const isIndustry = alertDetail?.alertTypeCode === ALERT_TYPE_CODE.INDUSTRY.key
  const isCompany = !isMacro && !isIndustry

  const { dataKey, key } = ALERT_TYPE_CODE[alertDetail.alertTypeCode] || {}
  const Panel = mapPanel[key]

  if (Object.keys(alertDetail).length && !dataKey) {
    return <Notification />
  }

  return (
    <Element className="wh100" style={{ backgroundColor: '#E5E5E5' }}>
      <ScrollComponent>
        <Element
          className={classes.container}
          style={{
            backgroundColor: '#FFFFFF',
            maxWidth:
              width > responsive.PIVOT_WIDTH ? responsive.PIVOT_WIDTH : '100%',
          }}
        >
          <BackButton />
          {isLoading ? (
            <Loading />
          ) : (
            <>
              <Header
                data={alertDetail}
                detailKey={dataKey}
                isCompany={isCompany}
                isIndustry={isIndustry}
              />
              <TriggerDate date={alertDetail.createDate} />
              <div className={classes.panels}>
                {isCompany && <Portfolios data={alertDetail.portfolios} />}
                <Panel data={alertDetail} detailKey={dataKey} />
                <Alerts
                  data={alertDetail}
                  isCompany={isCompany}
                  isMacro={isMacro}
                />
              </div>
            </>
          )}
        </Element>
        <Footer />
      </ScrollComponent>
    </Element>
  )
}
